import { Component, OnInit, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { CidaasService } from 'src/app/service/cidaas.service';
import { CommonFunctionsService } from 'src/app/service/common-functions.service';
import { Constants } from 'src/app/helpers/constant';
import {KEY_DEFAULT_ERROR} from '../../../model/error.model';
@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(url): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

@Component({
  selector: 'app-consent-preview',
  templateUrl: './consent-preview.component.html',
  styleUrls: ['./consent-preview.component.scss'],
})
export class ConsentPreviewComponent implements OnInit {
  actionType!: string;
  clientId!: string;
  consentId!: string;
  consentName!: string;
  consentVersion!: string;
  consentVersionId!: string;
  fieldKey!: string;
  groupname!: string;
  lang!: string;
  q!: string;
  requestId!: string;
  sub!: string;
  trackId!: string;
  consentUrl!: string;
  consentScopes!: any;
  buttonOptions: any = {
    accept: {
      color: 'accent',
      text: 'CONSENT_PREVIEW.ACCEPT',
      alignment: 'right',
      type: 'proceed',
      underline: 'none',
    },
  };
  errorMessage: string = '';
  showScopes: boolean = true;
  allowedFields: string[] = [];
  requiredFields: string[] = [];
  scopes: string[] = [];
  selectedFields: string[] = [];
  scopeName: string = '';
  step: number = -1;

  locale_language: any;
  scopesArray: any = []
  scopes_final_array: any = []
  required_fields_array: any = []

  constructor(private route: ActivatedRoute, private cidaas: CidaasService, public commonFunc: CommonFunctionsService) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.actionType = params.action_type || null;
      this.clientId = params.client_id || null;
      this.consentId = params.consent_id || null;
      this.consentName = params.consent_name || null;
      this.consentVersion = params.consent_version || null;
      this.consentVersionId = params.consent_version_id || null;
      this.fieldKey = params.field_key || null;
      this.groupname = params.groupname || null;
      this.lang = params.lang || navigator.language.split('-')[0];
      this.q = params.q || null;
      this.requestId = params.requestId || null;
      this.sub = params.sub || null;
      this.trackId = params.track_id || null;
      this.getConsent().then((res)=>{
      }).catch((err)=>{
      })
    });
  }

  private async getConsent(): Promise<void> {
    // const response = await this.cidaas._get().getConsentDetailsV2({
    //   consent_id: this.consentId,
    //   consent_version_id: this.consentVersionId,
    //   sub: this.sub,
    //   q: this.q,
    //   lang: this.lang,
    // });
    // if (response && response.data) {
    //   this.consentUrl = response.data.url;
    //   this.consentScopes = response.data.scopes;
    // } else if (response.error) {
    //   this.errorMessage = KEY_DEFAULT_ERROR;
    // }

    // console.log(`consentId ${this.consentId}, locale ${this.lang}`);
    const response = await this.cidaas._get()?.getScopeConsentVersionDetailsV2({
      scopeid: this.consentId,
      locale: this.lang,
    });
    this.locale_language = response?.data?.consent_locale?.locale
    if (response && response?.data) {
      this.consentUrl = response.data?.consent_locale?.url;
      this.consentScopes = response.data.scopes;
      this.consentScopes.map((x) => {
        this.scopes.push(x.scope);
        this.selectedFields = this.selectedFields.concat(x.allowed_fields_localText);
        this.selectedFields = this.selectedFields.filter((item, pos) => this.selectedFields.indexOf(item) === pos);
      });
      this.requiredFields = response.data.required_fields;
    } else if (response.error) {
      this.errorMessage = KEY_DEFAULT_ERROR;
    }
  }

  consentScopeFieldName(fieldsArray) {
    this.required_fields_array = []
      this.scopesArray = []
      outer:
      fieldsArray.forEach((element : any) => {
        if(element.localeText){
          inner:
          // element.localeText.forEach((element_inner) => {
            for(var i=0; i<element.localeText.length; i++) {
              let scope_object: any = {}
              if(element.localeText[i].language == this.lang) {
                this.scopes_final_array.push(element[Constants.FIELD_KEY])
                if(element.localeText[i][Constants.NAME] == undefined) {
                  scope_object[Constants.NAME] = element[Constants.FIELD_KEY]
                } else {
                  scope_object[Constants.NAME] = element.localeText[i][Constants.NAME]
                }
                if(this.requiredFields.includes(element[Constants.FIELD_KEY])) {
                  this.required_fields_array.push(element.localeText[i][Constants.NAME])
                }
                scope_object[Constants.FIELD_NAME] = element[Constants.FIELD_KEY]
                this.scopesArray.push(scope_object)
                break inner;
              } else {
                if (i == element.localeText.length - 1) {
                  this.scopes_final_array.push(element[Constants.FIELD_KEY])
                  scope_object[Constants.NAME] = element[Constants.FIELD_KEY]
                  scope_object[Constants.FIELD_NAME] = element[Constants.FIELD_KEY]
                  this.scopesArray.push(scope_object)
                }
              }
            }
          // });
        }
      });
      this.scopesArray = this.scopesArray.filter((e) => { return !this.required_fields_array.includes(e.name) });
      this.scopes_final_array = this.scopes_final_array.filter((e) => { return !this.required_fields_array.includes(e.field_name) });
    }

  async acceptConsent(): Promise<void> {
    await this.cidaas._get().acceptConsentV2({
      client_id: this.clientId,
      consent_id: this.consentId,
      consent_version_id: this.consentVersionId,
      sub: this.sub,
      scopes: this.scopes,
      accepted_fields: this.scopes_final_array,
      action_type: 'LOGIN',
      ...(this.consentUrl ? {url: this.consentUrl} : {})
    });
    this.consentContinue();
  }

  private async consentContinue(): Promise<void> {
    await this.cidaas._get().consentContinue({
      version: this.consentVersionId,
      sub: this.sub,
      client_id: this.clientId,
      name: this.consentName,
      track_id: this.trackId,
    });
  }

  _showFields = (index) => {
    this.showScopes = false;
    let allowedFields = this.consentScopes[index]['allowed_fields_localText'];
    this.scopeName = this.consentScopes[index]['scope'];
    this.step = index;
    this.consentScopeFieldName(allowedFields)
  };

  _showScopes = () => {
    this.showScopes = true;
  };

  _updateSelectedFields = (event: any, field: string) => {
    event?.checked ? this.scopes_final_array.push(field) : this.scopes_final_array.splice(this.scopes_final_array.indexOf(field), 1);
  };
}
